var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"loading":_vm.loading,"type":_vm.type,"size":_vm.size,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }